module.exports = __webpack_public_path__ + "static/media/desktop-logo.136809ca.svg";